/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Meta_DescriptionInputs */

const en_svc_n8n_meta_description = /** @type {(inputs: Svc_N8n_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`n8n development services for AI workflow automation: we design, build and maintain n8n workflows that connect your tools, with error handling and approvals built in.`)
};

const lv_svc_n8n_meta_description = /** @type {(inputs: Svc_N8n_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`n8n izstrāde AI darba plūsmu automatizācijai: projektējam, veidojam un uzturam n8n darba plūsmas, kas savieno Jūsu rīkus, ar kļūdu apstrādi un apstiprināšanu.`)
};

/**
* | output |
* | --- |
* | "n8n development services for AI workflow automation: we design, build and maintain n8n workflows that connect your tools, with error handling and approvals b..." |
*
* @param {Svc_N8n_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_meta_description = /** @type {((inputs?: Svc_N8n_Meta_DescriptionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Meta_DescriptionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_meta_description(inputs)
	return en_svc_n8n_meta_description(inputs)
});